module.exports = __webpack_public_path__ + "img/word_back.4827dd2d.jpg";